module.exports = __webpack_public_path__ + "img/horizontal_4_3_9005.50989e53.png";